<template>
    <el-dialog
      class="senior-logic"
      title="高级搜索"
      :visible.sync="logicPanelData.dialogVisible"
      @open="open()"
      center
      :close-on-click-modal="false"
      width="720px"
      append-to-body>
      <div class="dialog-content">
        <el-form label-width="70px" label-position="left">
          <el-form-item v-for="(filter,index) in model.filters" :key="filter.id" :prop="filter.id" :label="filter.name" :title="filter.name">
            <el-select v-model="filter.condition" placeholder="请选择" class="conditon-input">
              <el-option label="包含" value="includes"></el-option>
              <el-option label="等于" value="="></el-option>
              <el-option label="不等于" value="!="></el-option>
              <el-option label="大于" value=">"></el-option>
              <el-option label="大于等于" value=">="></el-option>
              <el-option label="小于" value="<"></el-option>
              <el-option label="小于等于" value="<="></el-option>
              <el-option label="空" value="isNull"></el-option>
              <el-option label="非空" value="notNull"></el-option>
            </el-select>
            <el-date-picker v-if="filter.columnType==='datetime'" v-model="filter.defaultValue" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期时间"></el-date-picker>
            <el-date-picker v-else-if="filter.columnType==='date'" v-model="filter.defaultValue" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
            <el-input v-else v-model="filter.defaultValue" placeholder="请输入"></el-input>
            <el-button class="operation-button" v-if="filter.otherCondition==='true'" @click="changeOperation(index)">{{filter.operationText}}</el-button>
            <el-button class="operation-button" v-else @click="filter.otherCondition='true'">+</el-button>
            <template v-if="filter.otherCondition==='true'">
              <el-select v-model="filter.condition2" placeholder="请选择" class="conditon-input">
                <el-option label="包含" value="includes"></el-option>
                <el-option label="等于" value="="></el-option>
                <el-option label="不等于" value="!="></el-option>
                <el-option label="大于" value=">"></el-option>
                <el-option label="大于等于" value=">="></el-option>
                <el-option label="小于" value="<"></el-option>
                <el-option label="小于等于" value="<="></el-option>
                <el-option label="空" value="isNull"></el-option>
                <el-option label="非空" value="notNull"></el-option>
              </el-select>
              <el-date-picker v-if="filter.columnType==='datetime'" v-model="filter.defaultValue2" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期时间"></el-date-picker>
              <el-date-picker v-else-if="filter.columnType==='date'" v-model="filter.defaultValue2" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
              <el-input v-else v-model="filter.defaultValue2" placeholder="请输入"></el-input>
            </template>
          </el-form-item>
       </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="operation-filter">
          条件间关系: <el-button class="operation-button" @click="changeOperationFilter"> {{operationFilter==='&'?'且':'或'}}</el-button>
        </div>
        <el-button type="primary" @click="saveExpression()">确定</el-button>
        <el-button @click="resetFilters()">清空</el-button>
        <el-button @click="logicPanelData.dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
</template>
<script>

export default {
  name: 'logic-panel',
  props: ['logicPanelData'],
  data () {
    return {
      model: {filters: []},
      operationFilter: '&'
    }
  },

  methods: {
    open () {
      if (this.model.filters.length === 0) {
        this.getReportColumns.forEach((el, index) => {
          this.model.filters.push({id: '', columnType: '', name: '', condition: 'includes', defaultValue: '', operation: '&', operationText: '且', condition2: 'includes', defaultValue2: '', otherCondition: 'false'})
          this.model.filters[index].id = el.id
          this.model.filters[index].name = el.name
          this.model.filters[index].columnType = el.columnType
        })
      }
    },
    changeOperationFilter () {
      this.operationFilter = this.operationFilter === '&' ? '|' : '&'
    },
    changeOperation (index) {
      // 修改条件间的关系
      this.model.filters[index].operation = this.model.filters[index].operation === '&' ? '|' : '&'
      this.model.filters[index].operationText = this.model.filters[index].operation === '&' ? '且' : '或'
    },
    saveExpression () {
      // 保存
      this.logicPanelData.filters = this.model.filters
      this.handlerExpression()
      this.logicPanelData.dialogVisible = false
      this.$emit('expression', this.logicPanelData)
    },
    handlerExpression () {
      let hasRalationFilters = []
      let filterFilters = this.logicPanelData.filters.filter(n => (n.condition && n.defaultValue) || (n.condition2 && n.defaultValue2) || n.condition === 'isNull' || n.condition === 'notNull' || n.condition2 === 'isNull' || n.condition2 === 'notNull')
      filterFilters.forEach(m => {
        hasRalationFilters.push('${' + m.id + '}')
      })
      this.logicPanelData.expression = hasRalationFilters.join(this.operationFilter)
    },
    resetFilters () {
      this.model.filters.forEach(el => {
        el.defaultValue2 = ''
        el.defaultValue = ''
        el.condition = 'includes'
        el.condition2 = 'includes'
        el.otherCondition = 'false'
      })
    }

  },
  computed: {
    getReportColumns () {
      if (this.logicPanelData.table.columns) {
        return this.logicPanelData.table.columns
      }
    }
  }

}
</script>
<style lang="scss">
.senior-logic {
  .el-dialog--center .el-dialog__body {
    padding: 25px 25px 0px 50px;

    .dialog-content {
      max-height: 280px;
      min-height: 200px;
      overflow: auto;
      padding-bottom: 0;

      .el-form-item--mini.el-form-item {
        margin-bottom: 13px;
      }

      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 5px 0 0;
      }

      .el-input {
        width: 150px;
        margin-right: 6px;
      }
      .conditon-input {
        .el-input {
          width: 90px;
        }
      }
      .el-input--prefix {
        .el-input__inner  {
          padding-left: 10px;
          padding-right: 10px;
        }
        .el-icon-time,.el-icon-date {
          display: none;
        }
      }
      .operation-button {
        padding: 0;
        width: 30px;
        height: 24px;
        margin-right: 6px;

        span {
          font-size: 12px;
        }
      }
    }
  }

  .el-dialog__footer {
    padding: 25px 50px 20px;

    .el-button {
      width: 104px;
    }

    .operation-filter {
      border-top: 1px solid #EBEBEB;
      text-align: left;
      padding-top: 12px;
      margin-bottom: 30px;

      .operation-button {
        padding: 0;
        width: 30px;
        height: 24px;

        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/senior-logic-panel.vue